<script lang="ts">
    import type {CalendarDate} from 'shared/components/kp-calendar/types';
    import {calendarDateFromLuxon} from 'shared/components/kp-calendar/utils';
    import {generateMockDonutData, dayOptimisationOverviewJobTypeSummariesMockData} from './mock-data';
    import {DateTime} from 'luxon';
    import KpDonutChart from 'shared/components/kp-charts/donut-chart/KpDonutChart.svelte';
    import OptimisationOverviewContainer from './components/OptimisationOverviewContainer.svelte';
    import OptimisationOverviewHeading from './components/OptimisationOverviewHeading.svelte';
    import DayOverviewJobTypeCard from './components/DayOverviewJobTypeCard.svelte';
    import ErpRowCalendar from 'src/features/erp/components/erp-row-calendar/ErpRowCalendar.svelte';

    let selectedDate = calendarDateFromLuxon(DateTime.now());

    function handleDateSelected(event: CustomEvent<CalendarDate>) {
        selectedDate = event.detail;
    }
</script>

<OptimisationOverviewContainer>
    <ErpRowCalendar startDate="{calendarDateFromLuxon(DateTime.now())}"
                    selectedDate="{selectedDate}"
                    on:date-selected={handleDateSelected}/>

    <OptimisationOverviewHeading heading="Denní přehled" printButtonLabel="Tisk montážního deníku"/>

    <div class="donut-chart-container">
        <KpDonutChart size="250px" data="{generateMockDonutData()}"/>
    </div>

    <div class="job-type-summaries-container">
        {#each dayOptimisationOverviewJobTypeSummariesMockData as jobTypeSummary}
            <DayOverviewJobTypeCard {jobTypeSummary}/>
        {/each}
    </div>
</OptimisationOverviewContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .job-type-summaries-container {
        display: flex;
        flex-direction: column;
        gap: @spacing-xl;
    }
</style>